















































import Vue from 'vue';
import validators from '@/validators';
import {PaymentMethod} from "@/classes/PaymentMethod";
import i18n from '@/plugins/i18n';

export default Vue.extend({
  components: {},
  props: {
    value: {
      type: Object as () => PaymentMethod,
    },
    paymentMethods: {
      type: Array as () => Array<PaymentMethod>
    },
    hideDivider: {
      type: Boolean,
      default: false
    },
    loading: Boolean,
  },
  data() {
    return {
      rules: {},
    };
  },
  computed: {
    paymentMethod: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit('update:value', newValue)
      }
    }
  },
  created() {
    // NOTE: This might be an issue if language is to be changed runtime
    Object.assign(this.rules, validators(this.$t('validation')));
  },
  methods: {
    changed() {
      this.$emit('change')
    },
    translatePaymentMethodName(paymentMethod: PaymentMethod): string {
      return i18n.translateEntityName(paymentMethod);
    },
    translatePaymentMethodDescription(paymentMethod: PaymentMethod): string {
      return i18n.translateEntityDescription(paymentMethod);
    },
  },
})
;
